import React, { createContext, useState } from 'react';
import Menu from '../menu/menu';
import Index from './index';
import Footer from '../footer/footer';
import Helmet from "react-helmet";

export const LanguageContext = createContext(null);

function Content() {
    const [language, setLanguage] = useState('eng');

    return(
            <LanguageContext.Provider value={{language: language, setLanguage: setLanguage}}>
                <Helmet link={[]} />
                <Menu />
                <Index />
                <Footer />
            </LanguageContext.Provider>
            )
}

export default Content